import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-button-icon',
  templateUrl: './button-icon.component.html',
  styleUrls: ['./button-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonIconComponent implements OnInit {
  @Input()
  icon: string;
  
  @Input()
  iconType: 'solid' | 'regular' = 'solid';

  @Input()
  iconPlacement: 'left' | 'bottom' = 'bottom';

  @Input()
  arrow: 'down' | 'up' | '' = '';

  @Input()
  color: 'light' | 'dark' | '' = '';

  @Input()
  label = '';

  constructor() { }

  ngOnInit() {
  }

}
